// 63版本相关多语言

export default {
    bankTransfer: {
        b000001: '待处理',
        b000002: '处理成功',
        b000003: '处理失败',
        b000004: '自动处理',
        b000005: '退款到账',
        b000006: '已取消',
        b000007: '转入',
        b000008: '转出',
        b000009: '付款',
        b000010: '全部',
        b000011: '没有更多了',
        b000012: '出入金记录',
        b000013: '换汇',
        b000014: '划转',
        b000015: '银行账户',
        b000016: '提交',
        b000017: '已绑定',
        b000018: '个',
        b000019: '暂无数据',
        b000020: '转账',
        b000021: '账户号码说明',
        b000022: '银行账号可能不同于银行卡上所展示的卡号， 请正确填写银行账号，如需帮助，请联系客服。',
        b000023: '如何找到银行账号？',
        b000024: '1、银行结单',
        b000025: '2、网银APP、网页',
        b000026: '3、银行开户资料',
        b000027: '4、银行卡片',
        b000028: '示例',
    },
    moneyExchange: {
        m000001: [
            "注意事项：",
            "1、暂不提供超过500000港币或等值货币的兑换。",
            "2、汇率仅做参考，实际汇率将按照处理时汇率为准。",
            "3、默认以换入货币计算换出货币，如需固定换出金额，请在备注中写明。",
        ],
        m000002: '备注',
        m000003: '由金额',
        m000004: '换汇至金额',
        m000005: '参考汇率',
        m000006: '更新',
        m000007: '可转出总计',
        m000008: "美元",
        m000009: "港币",
        m000010: "人民币",
        m000011: "换汇记录",
        m000012: "参考汇率",
        m000013: "暂不取消",
        m000014: "是否确认取消？",
        m000015: "取消成功",
        m000016: "订单编号",
        m000017: "取消",
        m000018: "资金换汇",
        m000019: ['待处理', '处理中', '处理成功', '处理失败', '已取消', '服务异常'],
        m000020: ['待处理','处理成功','处理失败','订单取消'],
        m000021: "换汇币种选择冲突",
    },
    fundsTransfer: {
        f000001: '转出账户',
        f000002: '不能为空',
        f000003: '转入账户',
        f000004: '币种',
        f000005: '金额',
        f000006: '资金划转',
        f000007: '验证登录密码',
        f000008: '温馨提示',
        f000009: '知道了',
        f000010: '资金划转订单提交成功',
        f000011: '密码不能为空',
        f000012: '资金划转记录',
        f000013: '预计1个工作日生效',
        f000014: '确认',
    },
    transferInto:{
        lang:'请选择汇款银行',
        lang0:'港元、美元、人民币',
        lang1: "填写并上传汇款凭证",
        lang2: {
            title: "存入币种",
            colums: [
                {
                    text: "港币",
                    value: "HKD"
                },
                {
                    text: "美元",
                    value: "USD"
                },
                {
                    text: "人民币",
                    value: "CNH"
                }
            ]
        },
        lang3:'存入账户',
        lang4:'存入金额',
        lang5:'请输入存入金额',
        lang6:'资金转入订单提交成功',
        lang7:'预计到账时间1~3个工作日',
        lang8:'知道了',
        lang9:'请选择存入币种',
        lang10:'请选择存入账户',
        accountName:["期货账户","证券账户"]
    },
    transferIntoAbroad:{
        lang:'按照下列信息填写汇款单',
        lang0:'手续费：同行免费',
        lang1:'到账时间：预计1~3个工作日内',
        lang2:'账户名称',
        lang3:'收款账号',
        lang4:'(港币)',
        lang5:'(美元)',
        lang6:'(人民币)',
        lang7:'银行名称',
        lang8:'银行地址',
        lang9:'复制',
        lang10:'我已汇款，上传凭证',
        tips: [
            "备注：",
            "为保障客户权益，汇款后请尽快上传入金凭证以供核对；",
            "如银行转帐涉及手续费，我司有机会在入帐后客户资金扣除；",
            "入金是根据银行工作时间作汇款安排，如非工作时段有机会延迟及衍生利息",
        ],
        lang11:'复制成功',
        lang12:'FPS转数快识别码',
    },
    withdrawNew:{
        lang:'账户列表',
        lang0:'转出币种',
        lang1:'请选择转出币种',
        lang2:'转出银行卡',
        lang3:'请选择需要转出的银行卡',
        lang4:'转出金额',
        lang5:'请输入转出金额',
        lang6:'全部余额',
        tips:[
          '资金转出说明',
          '1.汇率会在一定期限内变动，实际到账资金可能与预计到账金额存在差别；',
          '2.请确保您选择的银行卡能够接收您的转出币种，以免资金不能及时到账。'
        ],
        lang7:'验证登录密码',
        lang8:'资金转出订单提交成功',
        lang9:'预计到账时间1~3个工作日',
        lang10:'您未绑定银行卡', 
        lang11:'资金需要指定转出的银行卡',
        lang12:'暂不处理',
        lang13:'去绑定',
        lang14:'注意：银行卡必须能够接收上述币种'
    },
    agencyList:{
        lang:'消息通知',
        lang0:'验证邮件已发送至您的邮箱',
        lang1:'打开邮件激活',
        lang2:'若未能找到邮件，请在垃圾邮件中查找 如链接失效，请点击',
        lang3:'重新发送',
        lang4:[{name:'消息',value:1}, {name:'待办',value:2}],
        lang5:'发送成功',
        lang6:'则',
        lang7:'活动推送',
        lang8:'查看详情',
    },
    bankCardPage: {
        t00001: '请选择您的银行账户'
    },
    findPwd: {
        t00001: '如遇问题，请',
        t00002: '请输入开户的证件号码',
        t00003: '请设置登录密码',
        t00004: '你的账号为',
        t00005: '密码至少8个字符',
        t00006: '密码为数字和字母组合',
        t00007: '两次输入的新密码需要一致'
    },
    accountAnalysis: {
        a00001: '账户分析',
        a00002: '暂无数据',
        a00003: '统计时间',
        a00004: '资产图',
        a00005: '净值图',
        a00006: '资产',
        a00007: '累计净值',
        a00008: '数据加载中',
    },
    helpCenterNew: {
        m00000: '帮助中心',
        m00001: '请输入您遇到的问题',
        m00002: '搜索中...',
        m00003: '暂无搜索结果',
        m00004: '猜你想问',
        m00005: '问题分类',
        m00006: '其他',
        m00007: '',
        m00008: '',
        m00009: '',
    },
    privateFund: {
        title: '私募基金',
        bannerTitleLine1: '严选全球资管',
        bannerTitleLine2: '穿越周期配置',
        bannerSubtitle: '专业 · 稳健 · 长期价值',
        view: '查看',
        netValue: '资产管理规模（十亿）',
        returnYtd: '收益（年计）',
        returnSinceInception: '收益（月计）',
        list: {
            view: '查看',
            assetsUnderManagement: '资产管理规模（{unit}）',
            assetsUnderManagementPlain: '资产管理规模',
            assetsUnderManagementBillion: '资产管理规模（十亿）',
            assetsUnderManagementMillion: '资产管理规模（百万）',
            returnYtd: '收益（年计）',
            returnSinceInception: '收益（月计）',
        },
        disclaimer: {
            title: '免责声明及使用条款',
            paragraph1: '本文件所载之资料及文件乃由高盈证券有限公司（“高盈证券”）透过其移动应用程式提供及分发。',
            paragraph2: '本文件所载之资料及文件不应被视为对任何证券或投资产品之任何形式之推荐、要约、邀请、招揽、广告、劝诱或任何种类之陈述。其并不构成在任何司法管辖区向公众作出之要约或招揽。',
            paragraph3: '本文件所载之资料及文件仅供专业投资者（定义见香港法例第571章《证券及期货条例》）使用，并严格限于香港境内使用。 其并非供任何其他司法管辖区之人士分发或使用，而在该等司法管辖区进行有关分发或使用将违反当地法律或规例。除非事先获得高盈证券之书面同意，任何接收者不得以任何方式复制、分发或转发本文件所载之资料及文件或其中任何部分予任何其他人士。',
            copyright: '© 2026 高盈证券有限公司。保留一切权利。',
            confirm: '关闭',
        },
        finishedText: '没有更多了',
        listPlaceholder: '列表页开发中',
        detailPlaceholder: '详情页开发中',
        tabOverview: '基金概览',
        tabPerformance: '基金业绩',
        performanceNavTrend: '每股资产净值',
        performanceNavUnit: '（千美元）',
        performanceNavPeriod: '自成立以来(每月)',
        performanceChartNavLabel: '净值',
        navMiniChartTooltipValue: '每股资产净值：{value}',
        performanceChartNoData: '暂无数据',
        sectionOverview: '概况',
        sectionSubscription: '申购',
        sectionRedemption: '赎回',
        sectionFees: '费用',
        sectionStrategy: '投资策略',
        strategyPrefix: '主要投资策略: ',
        productName: '产品名称',
        fundCompany: '基金公司',
        currency: '币种',
        subscriptionDay: '申购日',
        subscriptionPrice: '申购价',
        minSubscription: '起购金额',
        additionalSubscription: '追加金额',
        shareLockUp: '份额锁定',
        redemptionDay: '赎回日',
        minRedemption: '最小赎回',
        minHolding: '最小持有',
        subscriptionFee: '申购费',
        redemptionFee: '赎回费',
        managementFee: '管理费',
        performanceFeeRatio: '业绩报酬计提比例',
        performanceFeeFrequency: '业绩报酬计提频率',
        learnMore: '进一步了解',
        subscribeApply: '认购申请',
        subscribe: {
            title: '认购申请',
            product: '认购产品',
            productNetValue: '产品净值',
            securitiesAccount: '证券账号',
            accountPlaceholder: '请输入证券账号',
            accountInvalid: '请输入证券账号',
            accountEmpty: '证券账号不能为空',
            amount: '认购金额',
            amountPlaceholder: '请输入金额',
            minAmountHint: '最小认购金额',
            estimatedShares: '预计认购份额',
            agreementPrefix: '本人已收悉、阅读及理解本基金的',
            agreementTerms: '《基金条款清单》',
            agreementMemo: '《私募配售备忘录》',
            agreementAppendix: '《基金附录》',
            agreementDisclosure: '《基金交易前披露确认声明》',
            agreementBetween: '、',
            agreementAnd: '及',
            agreementSuffix: '中的风险披露。我已明白本基金属复杂产品，并已理解上述所有风险。',
            submit: '提交',
            amountInvalid: '认购金额须大于0',
            minAmountInvalid: '认购金额低于起购金额',
            stepAmountInvalid: '认购金额须为起购金额加追加金额的整数倍',
            fundIdEmpty: '产品信息缺失，请返回重试',
            tokenEmpty: '请登录后操作，token 为空',
            submitSuccessMessage: '您的认购申请已提交，相关文件已寄至您的注册邮箱，请查收。客服将在1-3个工作日与您联系，完成后续认购流程',
            confirm: '确定',
        },
        order: {
            title: '基金订单',
            entry: '基金订单',
            colName: '名称',
            colAmount: '认购金额',
            colCurrency: '币种',
            colStatus: '状态',
            colTime: '认购时间',
            statusSubmitted: '已提交',
            statusAccepted: '已受理',
            statusRejected: '已拒绝',
            statusCancelled: '已取消',
        },
    }
}
